// Re-exported from @ird/ng-icons, which owns them: the proxy's old home here made ng-icons
// import ng-base, closing the cycle ng-base -> ng-headless -> ng-icons -> ng-base.
export { SpxIconRegistryProxyService } from '@ird/ng-icons';
export type { SpxIcon } from '@ird/ng-icons';
export * from './icon.component';
export * from './mat-icon-registry.testing';
export * from './material-symbols-outlined-icons';
